import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Redirect } from 'react-router'
import { bindActionCreators } from 'redux'

import { handleAPIError } from 'features/app/store/actions'
import { set as setSession, remove as removeSession } from 'features/session/store/actions'
import { get as getNotifications } from 'features/notifications/store/actions'
import { openPopup, closePopup } from 'features/popup/store/actions'
import RealTimeClient from 'features/realTimeClient'
import qs from 'qs'

import get from 'lodash/get'
import { handleOAuth } from './utils'
import { translations } from 'gipsy-misc'
import { calendar, contact } from 'gipsy-api'

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      setSession,
      removeSession,
      openPopup,
      closePopup,
      handleAPIError,
      getNotifications
    },
    dispatch
  )
})

class OauthCallback extends Component {
  constructor(props) {
    super(props)

    this.state = {
      redirectToLogin: false,
      redirectToInviteRequest: false,
      redirectToOnboarding: false,
      redirectToTodo: false,
      emailProvider: '',
      requestInviteEmail: ''
    }
  }

  componentDidMount = async () => {
    const searchParams = qs.parse(this.props.location.search, { ignoreQueryPrefix: true })
    if (searchParams.error) {
      this.exitToLogin()
    }
    if (!searchParams.code) {
      return
    }

    try {
      const { user, emailToSync, code, isSignup, emailProvider } = await handleOAuth(this.props.location)

      calendar.synchronize(emailToSync)

      try {
        await RealTimeClient.init(user.id)
      } catch (err) {
        console.error(err)
      }
      await this.props.actions.setSession(user)
      this.props.actions.getNotifications()

      if (isSignup) {
        this.setState({
          redirectToOnboarding: true,
          emailProvider: emailProvider,
          emailToSync: emailToSync
        })
      } else {
        contact.synchronize(emailToSync)

        if (code === 'timezoneChanged') {
          this.props.actions.openPopup(
            {
              message: get(translations, `message.success.timezoneChanged`),
              button: translations.general.ok.toUpperCase(),
              buttonClass: 'ok',
              action: 'onClose'
            },
            15 * 1000
          )
        }

        this.setState({
          redirectToTodo: true
        })
      }
    } catch (err) {
      if (err.data && err.data.code === 'invitations.needed') {
        this.exitToInviteRequest(err.data.message)
        return
      }
      this.props.actions.handleAPIError(err)
      this.exitToLogin()
    }
  }

  exitToInviteRequest = email => {
    this.props.actions.removeSession()
    this.setState({
      redirectToInviteRequest: true,
      requestInviteEmail: email
    })
  }

  exitToLogin = () => {
    this.props.actions.removeSession()
    this.setState({
      redirectToLogin: true
    })
  }

  render = () => {
    if (this.state.redirectToInviteRequest && window.location.pathname !== '/invite-request') {
      return (
        <Redirect
          to={{
            pathname: '/invite-request',
            state: { email: this.state.requestInviteEmail }
          }}
        />
      )
    }
    if (this.state.redirectToLogin && window.location.pathname !== '/login') {
      return <Redirect to="/login" />
    }
    if (this.state.redirectToOnboarding && window.location.pathname !== '/onboarding') {
      return (
        <Redirect
          to={{
            pathname: '/onboarding',
            state: {
              emailToSync: this.state.emailToSync,
              emailProvider: this.state.emailProvider
            }
          }}
        />
      )
    }
    if (this.state.redirectToTodo && window.location.pathname !== '/') {
      return <Redirect to="/" />
    }
    return <div />
  }
}

export default connect(
  null,
  mapDispatchToProps,
  null,
  {
    pure: true
  }
)(OauthCallback)



// WEBPACK FOOTER //
// ./src/pages/oauthCallback/index.js